import { useState, useEffect, PropsWithChildren } from "react";

// So the contex rendering doesn't blink. May not be needed.

interface DelayedFallbackProps {
  delay: number;
}

const DelayedFallback = ({
  delay,
  children,
}: PropsWithChildren<DelayedFallbackProps>) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (show) {
    return children;
  }

  return null;
};

export default DelayedFallback;
